export default {"src":"/_next/static/media/climate-control.4a14571c.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};